
<template>
    <div class="promotionGoodsList-component">
        <div class="list" v-if="type">
            <div class="goodsItem" v-for="goods of dataSource" :key="goods.spu_id" @click="buy(goods)">
                <div class="goodsPhoto">
                    <div class="box">
                        <img v-lazy="goods.goods_img" alt="">
                    </div>
                    <div class="sellout" v-if="goods.goods_sell_out">已售罄</div>
                </div>
                <div class="goodsName"><span class="van-multi-ellipsis--l2">{{goods.goods_name}}</span></div>
                <div class="goodsPrice van-ellipsis">
                    <span class="new">¥{{goods.goods_present_price}}<span v-if="sstoreType">起</span></span>
                    <span class="old" v-if="goods.goods_price">¥{{goods.goods_price}}</span>
                </div>
                <div class="buy">
                    <van-button :class="{grey: goods.goods_sell_out}" type="danger" round size="small">立即购买</van-button>
                </div>
            </div>
        </div>
        <div class="list2" v-else>
            <div class="goodsItem" v-for="goods of dataSource" :key="goods.spu_id" @click="buy(goods)">
                <div class="goodsPhoto">
                    <div class="box">
                        <img v-lazy="goods.goods_img" alt="">
                    </div>
                    <div class="sellout" v-if="goods.goods_sell_out">已售罄</div>
                </div>
                <div class="goodsName"><span class="van-multi-ellipsis--l2">{{goods.goods_name}}</span></div>
                <div class="goodsPrice van-ellipsis">
                    <span class="new">¥{{goods.goods_present_price}}<span v-if="sstoreType">起</span></span>
                    <span class="old" v-if="goods.goods_price">¥{{goods.goods_price}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
import { Button } from 'vant'
export default {
    name: 'promotionGoodsList',
    props: {
        dataSource: {
            type: Array,
            required: true
        },
        type: {
            tryp: Boolean,
            default: true
        },
        sstoreType: {
            type: Boolean,
            default: true
        }
    },
    components: {
        [Button.name]: Button,
    },
    data () {
        return {

        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
    },
    methods: {
        buy (goods) {
            const params = {value: {spec_id: goods.spec_id, spu_id: goods.spu_id}, cb: this.goPage}
            !this.sstoreType && Object.assign(params.value, {goods_type: goods.goods_type})
            this.$emit('callback', params)
        },
        goPage (params) {
            this.$router.push({
                path: this.sstoreType ? '/moreSstoreGoodsDetail' : '/goodsDetail', // true：跳转多店， false：跳转单店
                query: params
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "../../../assets/stylus/variables";

.promotionGoodsList-component
    padding 0 20px
    .list
        width 100%
        display flex
        flex-wrap wrap
        .goodsItem
            width 32.394366666%
            min-height 409px
            // margin-right 10px
            margin-bottom 10px
            overflow hidden
            background-color $fcWhite
            &:nth-child(3n)
                margin-left 5px
            &:nth-child(3n-1)
                margin-right 5px
                margin-left 5px
            &:nth-child(3n+1)
                margin-right 5px
            .goodsPhoto
                position relative
                width 100%
                // height 230px
                .box
                    position relative
                    width 100%
                    padding-top 100%
                    overflow hidden
                    img
                        position absolute
                        top 0
                        left 0
                        z-index 1
                        width 100%
                .sellout
                        position absolute
                        top 65px
                        right 0
                        left 0
                        z-index 2
                        width 100px
                        height 100px
                        line-height 100px
                        margin auto
                        background-color rgba(0, 0, 0, 0.5)
                        color $fcWhite
                        font-size $fontListTitle
                        border-radius 50%
                        text-align center
            .goodsName
                padding 28px 10px 22px
                font-size $fontLeastSmall
                line-height 30px
                height 54px
                color $black333
                overflow hidden
                word-break break-all
            .goodsPrice
                padding 0 10px
                // display flex
                // align-items flex-end
                line-height 1
                .new
                    font-size $fontSmall
                    color $fcRed
                .old
                    font-size $fontExtraLeastSmall
                    color $fcGreyish
                    text-decoration line-through
                    padding-left 10px
            .buy
                padding-top 18px
                padding-bottom 22px
                .van-button
                    display flex
                    align-items center
                    justify-content center
                    width 138px
                    height 28px
                    line-height 1
                    margin 0 auto
                    background-color $fcPriceColor
                    border-radius 14px
                    font-size $fontLeastSmall
                    &.grey
                        background-color $fcGrey
                        border-color $fcGrey
    .list2
        display flex
        flex-wrap wrap
        .goodsItem
            position relative
            margin-top 20px
            padding-bottom 31px
            width 48.5915%
            border-radius 16px
            background-color $fcWhite
            overflow hidden
            &:nth-child(odd)
                margin-right 10px
            &:nth-child(even)
                margin-left 10px
            .goodsPhoto
                position relative
                width 100%
                // height 346px
                .box
                    position relative
                    width 100%
                    padding-top 100%
                    overflow hidden
                    img
                        position absolute
                        top 0
                        left 0
                        z-index 1
                        width 100%
                .sellout
                        position absolute
                        top 98px
                        right 0
                        left 0
                        z-index 2
                        width 150px
                        height 150px
                        line-height 150px
                        margin auto
                        background-color rgba(0, 0, 0, 0.5)
                        color $fcWhite
                        font-size $fontListTitle
                        border-radius 50%
                        text-align center
            .goodsName
                padding 21px 26px 47px 21px
                height 64px
                color $black333
                font-size $fontSmall
                line-height 35px
                overflow hidden
                word-break break-all
            .goodsPrice
                padding 0 21px
                position absolute
                bottom 31px
                // display flex
                // align-items flex-end
                width 100%
                box-sizing border-box
                line-height 1
                .new
                    color #ff0000
                    font-size $fontBase
                .old
                    color $fcGreyish
                    font-size $fontlessBase
                    text-decoration line-through
                    padding-left 20px
</style>
